import { getApiBaseUrl as getConfiguredApiBaseUrl, getApiKey as getConfiguredApiKey } from 'fake-db/apiConfig'
import Mock from '../mock'
import shortId from 'shortid'
import axios from 'axios.js'
const getApiBase = () => getConfiguredApiBaseUrl()
const getApiKey = () => getConfiguredApiKey()
const isNotificationDebugEnabled = () => {
    try {
        return window?.__DEBUG_NOTIFICATIONS__ === true || localStorage.getItem('debug_notifications') === '1'
    } catch (e) {
        return false
    }
}

const extractNotificationsList = (raw) => {
    if (Array.isArray(raw)) return raw
    if (Array.isArray(raw?.data)) return raw.data
    if (Array.isArray(raw?.data?.data)) return raw.data.data
    if (Array.isArray(raw?.payload)) return raw.payload
    return []
}

const logNotificationDebug = (label, payload) => {
    if (!isNotificationDebugEnabled()) return
    try {
        // eslint-disable-next-line no-console
        console.log(`[notification-mock] ${label}`, payload)
    } catch (e) {
        // no-op
    }
}

const getAllNoticeServer = async ()=>{
    try {
        logNotificationDebug('getAllNoticeServer.request', {
            url: `${getApiBase()}/?apiKey=${getApiKey()}&route=notification/getAllNotificationList/`,
        })
        const response = await axios.get(`${getApiBase()}/?apiKey=${getApiKey()}&route=notification/getAllNotificationList/`);
        const list = extractNotificationsList(response?.data);
        logNotificationDebug('getAllNoticeServer.response', {
            raw: response?.data,
            listLength: Array.isArray(list) ? list.length : 0,
        })
        return list;
    } catch (e) {
        console.error('notification getAllNotificationList failed', e?.response?.data || e?.message || e)
        return [];
    }
};


const setNoticeServer = async (id)=>{
    try {
        logNotificationDebug('setNoticeServer.request', {
            id,
            url: `${getApiBase()}/?apiKey=${getApiKey()}&route=notification/setNotificationReady/`,
        })
        const response = await axios.post(`${getApiBase()}/?apiKey=${getApiKey()}&route=notification/setNotificationReady/`,{
            notificationId:id
        });
        const list = extractNotificationsList(response?.data);
        logNotificationDebug('setNoticeServer.response', {
            raw: response?.data,
            listLength: Array.isArray(list) ? list.length : 0,
        })
        return list;
    } catch (e) {
        console.error('notification setNotificationReady failed', e?.response?.data || e?.message || e)
        return [];
    }
};

const setClearServer = async (allNotice)=>{
    try {
        logNotificationDebug('setClearServer.request', {
            payload: allNotice,
            url: `${getApiBase()}/?apiKey=${getApiKey()}&route=notification/setClearNotification/`,
        })
        const response = await axios.post(`${getApiBase()}/?apiKey=${getApiKey()}&route=notification/setClearNotification/`,{
            allNotificationList:allNotice
        });
        const list = extractNotificationsList(response?.data);
        logNotificationDebug('setClearServer.response', {
            raw: response?.data,
            listLength: Array.isArray(list) ? list.length : 0,
        })
        return list;
    } catch (e) {
        console.error('notification setClearNotification failed', e?.response?.data || e?.message || e)
        return [];
    }
};


const NotificationDB = {
    list: [
        // {
        //     id: shortId.generate(),
        //     heading: 'Message',
        //     icon: {
        //         name: 'chat',
        //         color: 'primary',
        //     },
        //     timestamp: 1570702802573,
        //     title: 'New message from Devid',
        //     subtitle: 'Hello, Any progress...',
        //     path: 'chat',
        // },
        // {
        //     id: shortId.generate(),
        //     heading: 'Alert',
        //     icon: {
        //         name: 'notifications',
        //         color: 'error',
        //     },
        //     timestamp: 1570702702573,
        //     title: 'Server overloaded',
        //     subtitle: 'Traffice reached 2M',
        //     path: 'page-layouts/user-profile',
        // },
        // {
        //     id: shortId.generate(),
        //     heading: 'Message',
        //     icon: {
        //         name: 'chat',
        //         color: 'primary',
        //     },
        //     timestamp: 1570502502573,
        //     title: 'New message from Goustove',
        //     subtitle: 'Hello, send me details',
        //     path: 'chat',
        // },
    ],
}

Mock.onGet('/api/notification').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    logNotificationDebug('/api/notification.hit', {
        headers: config?.headers,
    })
    const AllNotificationList = await getAllNoticeServer();
    logNotificationDebug('/api/notification.reply', {
        listLength: Array.isArray(AllNotificationList) ? AllNotificationList.length : 0,
        listSample: Array.isArray(AllNotificationList) ? AllNotificationList.slice(0, 2) : [],
    })

    return [200, Array.isArray(AllNotificationList) ? AllNotificationList : []]


})

Mock.onPost('/api/notification/add').reply(async (config) => {
    const AllNotificationList = await getAllNoticeServer();
    const response = AllNotificationList
    return [200, response]
})

Mock.onPost('/api/notification/delete').reply(async (config) => {
    let { id } = JSON.parse(config.data);
    logNotificationDebug('/api/notification/delete.hit', { rawConfigData: config.data, id })

    const AllNotificationList = await setNoticeServer(id);
    const response = AllNotificationList.filter(
        (notification) => notification.id !== id
    )
    // NotificationDB.list = [...response]
    return [200, response]
})

Mock.onPost('/api/notification/delete-all').reply(async (config) => {
    let { noticeClearList } = JSON.parse(config.data);
    logNotificationDebug('/api/notification/delete-all.hit', { noticeClearList })
    const AllNotificationList = await setClearServer(noticeClearList);

    // const response = AllNotificationList.filter(
    //     (notification) => notification.id !== id
    // )

    NotificationDB.list = [...AllNotificationList]
    const response = NotificationDB.list;
    return [200, response]
})
